import { createAction } from '@reduxjs/toolkit';
import { store } from '../store';
import { invalidateDesignationsCache } from '../slices/userSlice';
import { fetchDesignations } from './designationActions';

// This action creator invalidates the designations cache and fetches fresh data
export const refreshDesignations = createAction('users/refreshDesignations', () => {
  // First, invalidate the cache
  store.dispatch(invalidateDesignationsCache());
  
  // Then fetch fresh designations data
  store.dispatch(fetchDesignations());
  
  return { payload: {} };
});
